import moment from 'moment';

/** @deprecated */
export const getDatePart = (date?: Date) =>
  moment(date || new Date())
    .startOf('day')
    .locale('sv-SE')
    .toDate();

/** @deprecated .toLocaleDateString('sv-SE', {year: 'numeric', month: '2-digit', day: '2-digit'}) */
export const dateToString = (date?: Date) => {
  const value = moment(date || new Date());
  value.locale('sv');
  return value.format('YYYY[-]MM[-]DD');
};

/** @deprecated .toLocaleDateString('sv-SE', {year: 'numeric', month: '2-digit', day: '2-digit'}) .toLocaleTimeString({ hour: "2-digit", minute: "2-digit" }}) */
export const dateTimeToString = (date?: Date) => {
  const value = moment(date || new Date());
  value.locale('sv');
  return value.format('YYYY[-]MM[-]DD[ ]HH[:]mm');
};

/** @deprecated use dateUtils weekNoToDate */
export const weekNoToDate = (year: number, week: number, days: number = 0) => {
  const value = moment({ year });
  if (value.isoWeek() === 1) {
    value.isoWeekday(1);
  } else {
    value.isoWeekday(8);
  }
  value.add((week - 1) * 7 + days, 'days').locale('sv-SE');
  return value.toDate();
};

/** @deprecated use dateUtils firstDayInYear*/
export const firstDayInYear = (date?: Date) => {
  const value = moment(date || new Date())
    .startOf('year')
    .locale('sv');
  return value.toDate();
};

/** @deprecated use dateUtils firstDayInMonth */
export const firstDayInMonth = (date?: Date) => {
  const value = moment(date || new Date())
    .startOf('month')
    .locale('sv');
  return value.toDate();
};

/** @deprecated use dateUtils firstDayInWeek*/
export const firstDayInWeek = (date?: Date) => {
  const value = moment(date || new Date())
    .startOf('day')
    .isoWeekday(1)
    .locale('sv');
  return value.toDate();
};

/** @deprecated */
export const weeksInYear = (date?: Date) => {
  return moment(date || new Date()).isoWeeks();
};

// FIXME
/** @deprecated */
export const getWeekDayInWeek = (year: number, month: number, day: number) => {
  const value = moment({ year, month, day });
  value.locale('sv');
  return value.toDate();
};

/** @deprecated */
export const getDayOfMonth = (day: number, date?: Date) => {
  date = date || new Date();
  const monthDay = Math.min(
    day,
    new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
  );
  return new Date(date.getFullYear(), date.getMonth(), monthDay);
};

/** @deprecated */
export const trunkToHour = (date?: Date) => {
  return moment(date || new Date())
    .minute(0)
    .second(0)
    .toDate();
};

/** @deprecated */
export const trunkToMin = (date?: Date) => {
  return moment(date || new Date())
    .second(0)
    .toDate();
};

/** @deprecated */
export const setHour = (date: Date, hour: number) => {
  return moment(date).hour(hour).toDate();
};

/** @deprecated */
export const setMin = (date: Date, min: number) => {
  return moment(date).minute(min).toDate();
};

/** @deprecated */
export const getLastMonday = (date: Date) => {
  return moment(date).startOf('isoWeek').toDate();
};

/** @deprecated */
export const incYear = (date: Date, years: number) => {
  return moment(date).add(years, 'years').toDate();
};

/** @deprecated */
export const incMonth = (date: Date, months: number) => {
  return moment(date).add(months, 'months').toDate();
};

/** @deprecated */
export const incDay = (date: Date, days: number) => {
  return moment(date).add(days, 'days').toDate();
};

/** @deprecated */
export const incHour = (date: Date, hours: number) => {
  return moment(date).add(hours, 'hours').toDate();
};

/** @deprecated */
export const incMin = (date: Date, minutes: number) => {
  return moment(date).add(minutes, 'minutes').toDate();
};

export const isStrongerMatch = (
  match: RegExpExecArray | null,
  match2: RegExpExecArray | null,
  assumeCentury: boolean,
  textLength: number
): boolean => {
  const matchCount = !match
    ? 0
    : match?.reduce((acc, x) => {
        if (x) {
          acc++;
        }
        return acc;
      }, 0);
  const match2Count = !match2
    ? 0
    : match2?.reduce((acc, x) => {
        if (x) {
          acc++;
        }
        return acc;
      }, 0);

  return (
    textLength <= 4 ||
    matchCount >= match2Count ||
    Boolean(
      assumeCentury &&
        match &&
        match2 &&
        match[1].length === 4 &&
        match2[1].length < 4
    )
  );
};
